import {UploadCloud} from '../Iconpack';
import {cn} from '../lib/utils';
import React, {useState} from 'react';
import 'react-toastify/dist/ReactToastify.css';

export interface FileUploadProps extends React.InputHTMLAttributes<HTMLInputElement> {
    disabled?: boolean;
    onUpload?: (file: FileList) => void;
}

export const FileUpload = ({disabled = false, className, style, onUpload, ...props}: FileUploadProps) => {
    const [isDragOver, setIsDragOver] = useState(false);

    const fileUploadClasses = cn(
        'flex flex-col center py-[1rem] px-[1.5rem]  bg-blue' +
            'border-fileUpload-borderColor hover:border-fileUpload-hoverColor bg-fileUpload-background ' +
            'rounded-fileUpload cursor-pointer justify-center items-center',
        disabled ? 'text-fileUpload-disabled' : '',
        isDragOver ? 'fileUpload-dragOver' : '',
        className,
    );

    const onFileUpload = (files: FileList | null) => {
        if (files && files.length > 0) {
            if (onUpload) {
                onUpload(files);
            }
        }
    };

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragOver(false);
    };

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragOver(false);

        const files = e.dataTransfer.files;
        onFileUpload(files);
    };

    const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target?.files;
        if (files && files.length > 0) {
            const newFileList = new DataTransfer();
            Array.from(files).forEach((file) => {
                newFileList.items.add(file);
            });
            onFileUpload(newFileList.files);
        }

        if (e.target) {
            e.target.value = '';
        }
    };

    return (
        <label htmlFor='fileUpload' className='cursor-pointer text-center'>
            <div
                className={fileUploadClasses}
                style={{...style, borderColor: isDragOver ? '#155EEF' : '', backgroundColor: '#F5F8FF'}}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}>
                <input
                    {...props}
                    id='fileUpload'
                    type='file'
                    accept='image/png, image/jpg, image/jpeg, image/webp, image/gif, image/svg, image/svg+xml'
                    multiple
                    hidden
                    disabled={disabled}
                    onChange={handleFileInputChange}
                />

                <div className='mb-[0.75rem] inline-flex rounded-paddedIcon border-[4.35px] border-icon-borderColor bg-icon-background p-[0.625rem] shadow-icon'>
                    <UploadCloud />
                </div>
                <div className='text-[0.8rem] md:text-[1rem]'>
                    <span className='font-bold'>
                        <span style={{color: isDragOver ? '#155EEF' : undefined}}>Click to upload</span>
                    </span>
                    <span> your image</span>
                    <span> or drag and drop</span>
                </div>
                <span className='text-[0.8rem] md:text-[1rem]'>JPEG, PNG, SVG, GIF, or WEBP (max. 16MB)</span>
            </div>
        </label>
    );
};
